<svg width="0" height="0" class="cg3-icon-sprite">
    <symbol id="wk-icon-no-records" viewBox="0 0 112 112" style="display: block">
        <g clip-path="url(#clip0_2692_1731)">
            <path
                d="M97.66 18.58L96.22 20.02C104.78 29.58 110 42.19 110 56C110 69.81 104.78 82.42 96.22 91.98L97.66 93.42C106.57 83.5 112 70.39 112 56C112 41.61 106.57 28.5 97.66 18.58Z"
                fill="#85BC20"
            />
            <path
                d="M91.98 96.22C82.42 104.78 69.81 110 56 110C42.19 110 29.58 104.78 20.02 96.22L18.58 97.66C28.5 106.57 41.61 112 56 112C70.39 112 83.5 106.57 93.42 97.66L91.98 96.22Z"
                fill="black"
            />
            <path
                d="M20.02 15.78C29.58 7.22 42.19 2 56 2C69.81 2 82.42 7.22 91.98 15.78L93.42 14.34C83.5 5.43 70.38 0 56 0C41.62 0 28.5 5.43 18.58 14.34L20.02 15.78Z"
                fill="#E5202E"
            />
            <path
                d="M15.78 91.98C7.22 82.42 2 69.81 2 56C2 42.19 7.22 29.58 15.78 20.02L14.34 18.58C5.43 28.5 0 41.62 0 56C0 70.38 5.43 83.5 14.34 93.42L15.78 91.98Z"
                fill="#007AC3"
            />
            <path d="M78 52H76V34.41L72.59 31H39.41L36 34.41V52H34V33.59L38.59 29H73.41L78 33.59V52Z" fill="black" />
            <path
                d="M79 77H33C31.35 77 30 75.65 30 74V57.7L34.46 51H77.53L81.99 57.7V74C81.99 75.65 80.65 77 78.99 77H79ZM32 58.3V74C32 74.55 32.45 75 33 75H79C79.55 75 80 74.55 80 74V58.3L76.46 53H35.54L32 58.3Z"
                fill="black"
            />
            <path d="M52 46V44H60V46" fill="black" />
            <path d="M60 68V70H52V68" fill="black" />
            <path
                d="M78 58.8L76.97 57H61C61 59.76 58.76 62 56 62C53.24 62 51 59.76 51 57H35.03L34 58.8V59H49.29C50.15 61.89 52.83 64 56 64C59.17 64 61.84 61.89 62.71 59H78V58.8Z"
                fill="black"
            />
            <path
                d="M73.76 35L71.76 33H40.24L38.24 35H49.29C50.15 37.89 52.83 40 56 40C59.17 40 61.84 37.89 62.71 35H73.76ZM56 38C53.95 38 52.2 36.76 51.42 35H60.57C59.8 36.76 58.04 38 55.99 38H56Z"
                fill="black"
            />
            <path d="M78 83H34V79H36V81H76V79H78V83Z" fill="black" />
        </g>
        <defs>
            <clipPath id="clip0_2692_1731">
                <rect width="112" height="112" fill="white" />
            </clipPath>
        </defs>
    </symbol>
</svg>
